import { render } from "./Edit_pen.vue?vue&type=template&id=35a1e561&scoped=true"
import script from "./Edit_pen.vue?vue&type=script&lang=js"
export * from "./Edit_pen.vue?vue&type=script&lang=js"

import "./Edit_pen.vue?vue&type=style&index=0&id=35a1e561&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a1e561"]])

export default __exports__